import React, { Component } from "react"
import config from "react-global-configuration"
import * as dateHelper from "../../helpers/date"
import BookingExtensionProducts from "../common/bookingExtensionProducts"

class ParkingExtendBookingList extends Component {
  static defaultProps = {
    autoSearch: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      isActive: true,
      isTracked: false,
    }
  }

  componentDidMount() {
    if (this.props.bookingResults) this.props.removeBooking()
  }

  getDate = (date) => {
    const day = dateHelper.formatDate(date, "dddd")
    const formattedDay = day.charAt(0).toUpperCase() + day.slice(1)
    const formattedDate = dateHelper.formatDate(date, "DD/MM/YYYY")
    return `${formattedDay} ${formattedDate}`
  }

  render() {
    if (!this.props.bookingExtension) return null

    if (!this.props.changeFromBooking) return null

    const { departureDate: cfDepartureDate, departureTime: cfDepartureTime } = this.props.bookingExtension.booking
    const { parking: cfParking, booking: cfBooking } = this.props.changeFromBooking
    const { booking, extras, parkingExtension } = this.props.bookingExtension
    const departureTimeChanged = !(parkingExtension.newDepartureDate === cfDepartureDate && parkingExtension.newDepartureTime === cfDepartureTime)
    if (!departureTimeChanged) return null

    const bookingExtension = this.props.bookingExtension
    const textKeys = config.get("textKeys.amendment.manage") || {}

    let formerDurationHours = parseFloat(
      (new Date(`${booking.departureDate}T${booking.departureTime}`) - new Date(`${booking.arrivalDate}T${booking.arrivalTime}`)) / (1000 * 60 * 60),
    )
    let newDurationHours = parseFloat(
      (new Date(`${bookingExtension.parkingExtension.newDepartureDate}T${bookingExtension.parkingExtension.newDepartureTime}`) -
        new Date(`${bookingExtension.booking.arrivalDate}T${bookingExtension.booking.arrivalTime}`)) /
        (1000 * 60 * 60),
    )

    const durationDelta = Math.abs(newDurationHours - formerDurationHours)
    const durationShorted = newDurationHours < formerDurationHours
    const durationDeltaHours = durationDelta % 24
    const durationDeltaDays = (durationDelta - durationDeltaHours) / 24

    let timeChangeHeadline = durationShorted
      ? textKeys.durationShortened || "Du har forkortet din booking med"
      : textKeys.durationExtended || "Du har forlænget din booking med"

    if (durationDeltaDays > 1) {
      timeChangeHeadline += ` ${durationDeltaDays} ${textKeys.durationChangeDaysPlural || "dage"}`
    } else if (durationDeltaDays > 0) {
      timeChangeHeadline += ` ${durationDeltaDays} ${textKeys.durationChangeDaySingular || "dag"}`
    }

    // don't write 0 days
    if (durationDeltaDays > 0 && durationDeltaHours > 0) {
      timeChangeHeadline += ` ${textKeys.durationChangeAnd || "og"}`
    }

    if (durationDeltaHours > 1) {
      timeChangeHeadline += ` ${durationDeltaHours} ${textKeys.durationChangeHoursPlural || "timer"}`
    } else if (durationDeltaHours > 0) {
      timeChangeHeadline += ` ${durationDeltaHours} ${textKeys.durationChangeHourSingular || "time"}`
    }
    // don't write 0 hours

    const previousBookingHasPromotionDiscount = !!cfBooking?.promotionCode && cfBooking?.promotionSaving > 0 ? true : false
    const previousBookingIsAffiliate =
      !!cfBooking?.affiliateCode && !cfBooking.useMemberPrice && cfParking?.amount < cfParking.originalAmount ? true : false

    //price variables
    const previousBookingPrice =
      cfBooking.useMemberPrice || previousBookingHasPromotionDiscount || previousBookingIsAffiliate || cfParking.isParkingUpgrade
        ? cfParking.amount
        : cfParking.originalAmount // prePay for previous booking - no extra products
    let priceChange = parkingExtension.priceChange < 0 && !parkingExtension.allowRefund ? 0 : parkingExtension.priceChange // if priceChange is less than 0 and refund is not allowed, set price change to 0
    let subtotal = previousBookingPrice + priceChange
    let isPayment = priceChange > 0

    const confirmAndCheckoutButtonText = isPayment
      ? `${textKeys.confirmToPayment || "Bekræft & gå til betaling"}`
      : `${textKeys.confirmToOverview || "Gå til overblik"}`

    return (
      <div className="amendflow extend-data">
        <section className="deck deck--white">
          <div className="w--wider greybg">
            <div className="amenddata">
              <div className="data">
                <div className="grid">
                  <div className="grid-item col--12">
                    <h4>{timeChangeHeadline}</h4>
                  </div>
                  <div className="grid-groups grid-item col--12">
                    <div className="booking-time-flex-wrapper">
                      {departureTimeChanged ? (
                        <>
                          <div className="grid-line-three">
                            <div className="dataline strikethrough">{textKeys.formerDepartureLabel || "Gammel udkørselstid:"}</div>
                            <div className="dataline strikethrough">
                              {this.getDate(bookingExtension.booking.departureDate)} ({bookingExtension.booking.departureTime})
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {departureTimeChanged ? (
                        <>
                          <div className="grid-line-four">
                            <div className="dataline">{textKeys.newDepartureLabel || "Ny udkørselstid"}</div>
                            <div className="dataline">
                              {this.getDate(bookingExtension.parkingExtension.newDepartureDate)} ({bookingExtension.parkingExtension.newDepartureTime}
                              )
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="clear"></div>
              </div>
            </div>
            {this.props.bookingExtension ? (
              <BookingExtensionProducts
                isUnavailable={false}
                originalBooking={booking}
                isUpsaleable={false}
                result={this.props.bookingExtension.result}
                carPark={this.props.bookingExtension.carPark}
                product={this.props.bookingExtension.product}
                extras={extras}
                noLastStyling={true}
                isAmendment={true}
                getExtraPrice={this.props.getExtraPrice}
                isFullValueCancellation={this.isFullValueCancellation}
                isExtendedRefundCancellation={this.isExtendedRefundCancellation}
                isCancelled
                {...this.props}
              />
            ) : (
              ""
            )}
          </div>
          <div className="w--wider">
            <div /*className={"form--parking__calc"}*/>
              {" "}
              {/*enabling this class seperates pricing details from CTA button with an HR*/}
              <ul className="form--parking__calc__list">
                <li>
                  <p>{textKeys.orderSubtotalText || "Subtotal"}</p>
                  <p>{this.props.priceFormatter(subtotal)}</p>
                </li>
                <li>
                  <p>{textKeys.orderPreviousPayment || "Tidligere betalt"}</p>
                  <p>{this.props.priceFormatter(previousBookingPrice)}</p>
                </li>
                <li>
                  <h4>
                    {priceChange === 0
                      ? "Total"
                      : priceChange > 0
                        ? textKeys.orderAdditionalPaymentMessage || "Du skal betale"
                        : textKeys.orderRefundMessage || "Du bliver refunderet"}
                  </h4>
                  <h4>{this.props.priceFormatter(priceChange)}</h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="w--wider button-group">
            {this.props.bookingExtension ? (
              <>
                <p>
                  <button
                    className="button button--medium button--general"
                    onClick={() => this.props.handleBookingExtension(parkingExtension.newDepartureDate + "T" + parkingExtension.newDepartureTime)}
                  >
                    {confirmAndCheckoutButtonText}
                  </button>
                </p>
              </>
            ) : (
              ""
            )}
          </div>
        </section>
      </div>
    )
  }
}

export default ParkingExtendBookingList
